import { DocumentTypeSchema } from "@src/sudozi-schemas/document-type-schema";
import { z } from "zod";

const Document = z.object({
  id: z.string(),
  name: z.string(),
  displayName: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  type: z.array(DocumentTypeSchema),
  mimeType: z.string(),
  signedDownloadUrl: z.string(),
  uploadedByUser: z
    .object({
      id: z.string(),
      firstName: z.string(),
      lastName: z.string(),
      email: z.string(),
    })
    .nullish(),
  commentLine: z
    .object({
      id: z.string(),
      body: z.string(),
      createdAt: z.string(),
      updatedAt: z.string(),
      user: z.object({
        id: z.string(),
        firstName: z.string(),
        lastName: z.string(),
        email: z.string(),
      }),
    })
    .nullable(),
});

export const GetIntakeSubmissionDocumentsOutput = z.object({
  fromAnswers: z.array(Document),
  linked: z.array(Document),
});

export type GetIntakeSubmissionDocumentsOutput = z.infer<
  typeof GetIntakeSubmissionDocumentsOutput
>;
